import { useState } from "react";
import ProfileState from "../../model/Profile";
import UserInfo from "../../model/userInfo";
import { setProfileUser } from "../providers/profile";

export function useProfile(): [ProfileState, Function] {
    const [state, setState] = useState({
        user: { name: "", country: "", username: "", image: "" },
    });

    return [state, (user: UserInfo) => setProfileUser(setState, user)];
}
